export default {
  default: 'Thanx Dashboard',
  terms_default: 'Thanx Terms and Conditions',
  privacy_default: 'Thanx Privacy Policy',
  terms_branded: '%{name} Rewards Terms and Conditions',
  privacy_branded: '%{name} Rewards Privacy Policy',
  feedback: 'Respond to customer feedback - Feedback | Thanx',
  'feedback/trends': 'Sentiment analysis - Feedback | Thanx',
  'feedback/return_rate': 'Return rate - Feedback | Thanx',
  'feedback/report_card': 'Report card - Feedback | Thanx',
  'customer_insights/top_customers': 'Top members | Thanx',
  members: 'All customers | Thanx',
  member_profile: 'Member profile | Thanx',
  'customer_insights/quartile': 'Quartile | Thanx',
  'customer_insights/frequency': 'Frequency | Thanx',
  subscriptions: 'Email subscribers | Thanx',
  manage_users: 'Dashboard access | Thanx',
  rewards_report: 'Rewards accounting | Thanx',
  daily_activity: 'Daily activity | Thanx',
  purchases: 'Purchases | Thanx',
  revenue: 'Revenue | Thanx',
  captureRate: 'Revenue capture rate | Thanx',
  performance_reviews: 'Program reviews | Thanx',
  exclusive_deals: 'Exclusive deals | Thanx',
  '/brand_content': 'Brand & content | Thanx',
  '/brand_content#ordering_home_page':
    'App home page - Brand & content | Thanx',
  '/brand_content#web_hero_image': 'Web hero image - Brand & content | Thanx',
  '/brand_content#alert_banner':
    'Alert banner styling - Brand & content | Thanx',
  '/brand_content#custom_links': 'Custom links - Brand & content | Thanx',
  '/brand_content#exclusive_deals': 'Exclusive deals - Brand & content | Thanx',
  '/brand_content#brand_assets': 'Brand assets - Brand & content | Thanx',
  '/brand_content#app_store_assets':
    'App store assets - Brand & content | Thanx',
  '/brand_content#launch_screens': 'Launch screens - Brand & content | Thanx',
  '/brand_content#tiers': 'Tiers - Brand & content | Thanx',
  '/brand_content#social_links': 'Social media links - Brand & content | Thanx',
  '/brand_content#custom_fonts': 'Custom fonts - Brand & content | Thanx',
  '/brand_content#locations': 'Locations - Brand & content | Thanx',
  '/brand_content#smart_links': 'Smart links - Brand & content | Thanx',
  '/brand_content#ordering_configuration':
    'Ordering configuration - Brand & content | Thanx',
  '/brand_content#receipt_settings':
    'Receipt settings - Brand & content | Thanx',
  '/brand_content#analytics':
    'Facebook & Google Analytics - Brand & content | Thanx',
  '/brand_content#signup_message': 'Signup message - Brand & content | Thanx',
  '/settings': 'Settings | Thanx',
  '/settings#ordering_configuration':
    'Ordering configuration - Settings | Thanx',
  '/settings#receipt_settings': 'Receipt settings - Settings | Thanx',
  '/settings#unavailable_item_visibility': '86ed items - Settings | Thanx',
  '/settings#time_based_menu_visibility':
    'Time-based menu items - Settings | Thanx',
  '/settings#delivery_default_logic': 'Delivery default - Settings | Thanx',
  '/settings#ordering_error_messages':
    'Ordering error messages - Settings | Thanx',
  '/settings#preferences_modal_setting':
    'Location selection - Settings | Thanx',
  '/settings#scannable_codes': 'Scannable codes - Settings | Thanx',
  '/settings#post_order_feedback':
    'Post order receipt emails - Settings | Thanx',
  '/settings#instore_purchase_tracking':
    'In-store purchase tracking - Settings | Thanx',
  '/settings#instore_enrollment': 'In-store enrollment - Settings | Thanx',
  '/settings#terms_and_policies': 'Terms and policies - Settings | Thanx',
  '/settings#analytics': 'Meta and Google Analytics - Settings | Thanx',
  '/reports/ordering_conversion':
    'Cart conversion - Ordering conversion | Thanx',
  '/reports/ordering_conversion#cart_conversion':
    'Cart conversion - Ordering conversion | Thanx',
  '/reports/ordering_conversion#unaccepted_carts':
    'Unaccepted carts - Ordering conversion | Thanx',
  '/reports/ordering_error_report': 'Ordering error report | Thanx',
  '/alert_banners': 'Alert banner settings | Thanx',
  '/reports/app_downloads#app_downloads': 'App downloads | Thanx',
  '/reports/app_downloads#app_installs_per_location_per_month':
    'App installs per location per month - App downloads | Thanx',
  '/reports/app_downloads#first_purchases_and_app_adoption_by_location':
    '1st purchases and app adoption by location - App downloads | Thanx',
  '/reports/average_check#overview': 'Overview - Average check | Thanx',
  '/reports/average_check#handoff_mode': 'Handoff mode - Average check | Thanx',
  '/reports/average_check#location': 'Locations - Average check | Thanx',
  '/reports/engagement#overview': 'Overview - Engagement | Thanx',
  '/reports/engagement#average_monthly_value':
    'Average Monthly Value - Engagement | Thanx',
  '/reports/engagement#engaged_customers_per_location':
    'Engaged customers per location - Engagement | Thanx',
  '/reports/engagement#active_customers_at_select_locations':
    'Active customers at select location(s) - Engagement | Thanx',
  '/reports/engagement#average_active_customers_per_location_per_month':
    'Average active customers per location per month - Engagement | Thanx',
  '/reports/tiers#overview': 'Overview - Tiers | Thanx',
  '/reports/tiers#activity': 'Activity - Tiers | Thanx',
  '/reports/tiers#configuration': 'Configuration - Tiers | Thanx',
  '/reports/feedback': 'Overview - Feedback | Thanx',
  '/reports/feedback#overview': 'Overview - Feedback | Thanx',
  '/reports/feedback#details': 'Details - Feedback | Thanx',
  '/order_feedback#overview': 'Overview - Order feedback | Thanx',
  '/order_feedback#feedback': 'Feedback - Order feedback | Thanx',
  '/order_feedback#settings': 'Settings - Order feedback | Thanx',
  '/order_ratings': 'Order ratings | Thanx',
  '/reports/frequency': 'Frequency | Thanx',
  '/reports/promo_codes#campaign_performance':
    'Campaign performance - Promo codes | Thanx',
  '/reports/promo_codes#code_utilization':
    'Code utilization - Promo codes | Thanx',
  '/reports/promo_codes#geographic_breakdown':
    'Geographic breakdown - Promo codes | Thanx',
  '/reports/promo_codes#channel_breakdown':
    'Channel breakdown - Promo codes | Thanx',
  'reports/membershipoverview': 'Membership overview | Thanx',
}
